import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminComponent } from './layout/pages/admin/admin.component';
import { HomeComponent } from './layout/pages/home/home.component';
import { WeldCertificationComponent } from './layout/pages/weld-certification/weld-certification.component';
import { WeldLogComponent } from './layout/pages/weld-log/weld-log.component';
import { ReportingComponent } from './layout/pages/reporting/reporting.component';
import { GenericErrorComponent } from './layout/shared/error/generic-error/generic-error.component';
import { NotAuthorizedComponent } from './layout/shared/error/not-authorized/not-authorized.component';
import { PageNotFoundComponent } from './layout/shared/error/page-not-found/page-not-found.component';
import { UserPermissionsGuard } from './guards/app-routing.guard';

// for lazy loading:
//         loadComponent: () => import('./home/home.component').then(m => m.HomeComponent),

const REPORTING_ROUTES: Routes = [
  {
    path: '',
    children: [
      {
        path: 'weld-stats',
        canActivate: [UserPermissionsGuard],
        loadComponent: () => import('./layout/pages/reporting/reporting.component').then(m => m.ReportingComponent)
      },
      {
        path: 'welder-stats',
        canActivate: [UserPermissionsGuard],
        loadComponent: () => import('./layout/pages/reporting/reporting.component').then(m => m.ReportingComponent)
      },
      {
        path: 'welder-stamp-id-history',
        canActivate: [UserPermissionsGuard],
        loadComponent: () => import('./layout/pages/reporting/reporting.component').then(m => m.ReportingComponent)
      }
    ]
  }
];

// Admin routes for lazy loading
const ADMIN_ROUTES: Routes = [
  {
    path: '',
    children: [
      { path: 'user', loadComponent: () => import('./layout/pages/admin/admin.component').then(m => m.AdminComponent) },
      {
        path: 'welder',
        loadComponent: () => import('./layout/pages/admin/admin.component').then(m => m.AdminComponent)
      },
      {
        path: 'contract-company',
        loadComponent: () => import('./layout/pages/admin/admin.component').then(m => m.AdminComponent)
      },
      {
        path: 'contract-welder',
        loadComponent: () => import('./layout/pages/admin/admin.component').then(m => m.AdminComponent)
      },
      {
        path: 'filler-materials',
        loadComponent: () => import('./layout/pages/admin/admin.component').then(m => m.AdminComponent)
      },
      {
        path: 'materials',
        loadComponent: () => import('./layout/pages/admin/admin.component').then(m => m.AdminComponent)
      },
      {
        path: 'pipe-sizes',
        loadComponent: () => import('./layout/pages/admin/admin.component').then(m => m.AdminComponent)
      },
      { path: 'wps', loadComponent: () => import('./layout/pages/admin/admin.component').then(m => m.AdminComponent) },
      {
        path: 'switchsite',
        loadComponent: () => import('./layout/pages/admin/admin.component').then(m => m.AdminComponent)
      },
      {
        path: 'email',
        loadComponent: () => import('./layout/pages/admin/admin.component').then(m => m.AdminComponent)
      },
      {
        path: 'division',
        loadComponent: () => import('./layout/pages/admin/admin.component').then(m => m.AdminComponent)
      },
      { path: 'unit', loadComponent: () => import('./layout/pages/admin/admin.component').then(m => m.AdminComponent) },
      {
        path: 'group',
        loadComponent: () => import('./layout/pages/admin/admin.component').then(m => m.AdminComponent)
      },
      {
        path: 'rtpercentage',
        loadComponent: () => import('./layout/pages/admin/admin.component').then(m => m.AdminComponent)
      },
      {
        path: 'weldprocess',
        loadComponent: () => import('./layout/pages/admin/admin.component').then(m => m.AdminComponent)
      },
      {
        path: 'rolepermission',
        loadComponent: () => import('./layout/pages/admin/admin.component').then(m => m.AdminComponent)
      },
      {
        path: 'super-admin',
        canActivate: [UserPermissionsGuard],
        loadComponent: () =>
          import('./layout/pages/admin/super-admin/super-admin.component').then(m => m.SuperAdminComponent)
      }
    ]
  }
];

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'log', component: WeldLogComponent, canActivate: [UserPermissionsGuard] },

  {
    path: 'reporting',
    loadChildren: () => Promise.resolve(REPORTING_ROUTES)
  },
  {
    path: 'continuity',
    component: WeldCertificationComponent,
    canActivate: [UserPermissionsGuard]
  },
  {
    path: 'admin',
    loadChildren: () => Promise.resolve(ADMIN_ROUTES)
  },

  {
    path: 'welder-qualification',
    loadComponent: () => import('./layout/pages/qw484/weld-inspection.component').then(m => m.WeldInspectionComponent)
  },
  {
    path: 'q484-add-edit',
    loadComponent: () =>
      import('./layout/pages/qw484/qw484-add-edit-view/qw484_add_edit_view.component').then(
        m => m.Qw484AddEditViewComponent
      )
  },

  {
    path: 'error',
    children: [
      { path: 'generic', component: GenericErrorComponent },
      { path: 'not-authorized', component: NotAuthorizedComponent },
      { path: 'page-not-found', component: PageNotFoundComponent }
    ]
  },
  { path: '**', component: PageNotFoundComponent },
  { path: '', component: HomeComponent, pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}

//  ,canActivate: [UserPermissionsGuard]
